import { createFileRoute } from "@tanstack/react-router";

import { GoogleSheetsFormPage } from "~/pages/connection-new/google-sheets-form.page";

export const Route = createFileRoute(
  "/_app/settings/_organization/connections/new/_connection/google_sheets",
)({
  component: GoogleSheetsFormPage,
});
